import { render, staticRenderFns } from "./AcceptBookingExtraPaymentModal.vue?vue&type=template&id=4be940e3"
import script from "./AcceptBookingExtraPaymentModal.vue?vue&type=script&lang=js"
export * from "./AcceptBookingExtraPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports